import { render, staticRenderFns } from "./GameArea.vue?vue&type=template&id=1a2334fc&scoped=true&"
import script from "./GameArea.vue?vue&type=script&lang=js&"
export * from "./GameArea.vue?vue&type=script&lang=js&"
import style0 from "./GameArea.vue?vue&type=style&index=0&id=1a2334fc&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2334fc",
  null
  
)

export default component.exports